import * as Paginator from "react-bootstrap-table2-paginator";

import { Card, Col, Form, Row } from "react-bootstrap";
import { Field, Formik } from "formik";
import React, { useEffect, useState } from "react";
import ToolkitProvider, {
  CSVExport,
  Search,
} from "react-bootstrap-table2-toolkit";
import {
  faDownload,
  faPlus,
  faSearch,
} from "@fortawesome/free-solid-svg-icons";
import filterFactory, { textFilter } from "react-bootstrap-table2-filter";
import {
  getAllFieldIssueByDate,
  getFieldIssueExcelDownload,
  getFieldIssuePdfDownload,
  getServiceFieldIssueExcel,
  getServiceFieldIssuePdf,
} from "../../Service/AllServicesAPI";

import Axios from "../../utils/axiosInstance";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import Pagination from "react-bootstrap-table2-paginator";
import Select from "react-select";
import Table from "react-bootstrap-table-next";
import cellEditFactory from "react-bootstrap-table2-editor";
import fileSaver from "file-saver";
import { getCustomerList } from "../master/AllUserDropDown";
import { getFieldHistory } from "../../Service/AllReportAPI";
import moment from "moment";
import swal from "sweetalert";
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";

// import { getWorkOrderFieldIssueList, } from "../../Service/AllWorkOrderFieldIssueAPI";

export default () => {
  const { SearchBar } = Search;
  const [entries, setEntries] = useState([]);
  const { ExportCSVButton } = CSVExport;
  const selectRow = {
    mode: "checkbox",
  };
  const [changeRowData, setChangeRowData] = useState({
    selectedRow: [],
    cellChange: "",
    columnChange: [],
  });
  const [customerName, setCustomerName] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState("");
  // --- pagination
  const [currentPage, setcurrentPage] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const [isLoaded, setisLoaded] = useState(false);
  const [offset, setOffset] = useState(0);
  const [totaloffset, setTotaloffset] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  let role = sessionStorage.getItem("role");

  useEffect(() => {
    getFieldIssueHistory();
    // eslint-disable-next-line
  }, []);

  // Function declaration of get customers list
  const getCustomersList = async () => {
    await getCustomerList().then((result) => {
      setCustomerName(result);
    });
  };

  // const getFieldIssueListByFromDate = (e) => {
  //   setFromDate(e.target.value);
  //   console.log(fromDate);
  //   if (e.target.value > new Date().toISOString().split("T")[0]) {
  //     swal("Sorry", "Please select today or day before today", "warning");
  //   }
  // };

  // const getFieldIssueListByToDate = async (e) => {
  //   setToDate(e.target.value);
  //   console.log(toDate);
  //   if (e.target.value > new Date().toISOString().split("T")[0]) {
  //     swal("Sorry", "Please select today or day before today", "warning");
  //   }
  // };

  const handleFromDateChange = (date) => {
    setFromDate(date);
    // Clear the "To" date if it's before the selected "From" date
    if (toDate && date > toDate) {
      setToDate(null);
    }
  };

  const handleToDateChange = (date) => {
    if (date < fromDate) {
      swal('Invalid Date', 'The "To" date cannot be before the "From" date.', 'warning');
      setToDate(null); // Reset "To" date if invalid
    } else {
      setToDate(date);
    }
  };

  const getFieldByDate = async () => {
    try {
      if (fromDate !== "" && toDate !== "") {
        await getAllFieldIssueByDate(
          currentPage,
          moment(fromDate).format("yyyy-MM-DD"),
          moment(toDate).format("yyyy-MM-DD")
        )
          .then((result) => {
            console.log("Get Date wise Field Issue Result", result);
            if (result?.data?.content?.length !== 0) {
              const data = result.data.content;
              setEntries(data);
              setPageCount(result.data.totalPages);
              setTotalCount(result.data.totalElements);
              setToDate("")
              setFromDate("")
            } else {
              setEntries([]);
              setPageCount();
              setTotalCount();
              swal("Sorry", "Data is not present", "warning");
            }
            // console.log("setNoOfElements", noOfElements);
          })
          .catch((error) => {
            console.log("Get Field Issue Error", error);
          });
      } else {
        swal("Failed", "Please select date", "error");
      }
    } catch (error) {
      console.log(error);
      swal(
        "Failed",
        "Something went wrong please check your internet",
        "error"
      );
    }
  };

  const handlePageChange = async (page) => {
    let selectedPage = page - 1;
    setEntries([]);
    const role = sessionStorage.getItem("role");
    const fkUserId = sessionStorage.getItem("pkUserId");
    const token = sessionStorage.getItem("token");
    const headers = { Authorization: `Bearer ${token}` };
    await getFieldHistory(selectedPage, fkUserId, role, headers)
      .then((result) => {
        console.log("Get Pagination Production Result", result.data);
        if (result?.data?.content?.length !== 0) {
          const data = result.data.content;
          const totalSize = result.data.pageable.offset;
          entries.map((item, index) => (item.id = totalSize + index + 1));
          console.log("totalSize", totalSize);
          console.log("data", data);
          setEntries(data);
          setTotaloffset(totalSize);
          setTotalCount(result.data.totalElements);
        } else {
          swal("Sorry", "Data is not present", "warning");
        }
      })
      .catch((error) => console.error("Error", error));
    console.log("entries", entries);
  };

  // Function declaration of get field visit list
  const getFieldIssueHistory = async () => {
    try {
      const role = sessionStorage.getItem("role");
      const fkUserId = sessionStorage.getItem("pkUserId");
      const token = sessionStorage.getItem("token");
      const headers = { Authorization: `Bearer ${token}` };
      await getFieldHistory(currentPage, fkUserId, role, headers)
        .then((result) => {
          console.log("Work Order FieldIssue Result List", result);
          if (result?.data?.content?.length !== 0) {
            const data = result.data.content;
            setEntries(data);
            setPageCount(result.data.totalPages);
            setTotalCount(result.data.totalElements);
          } else {
            setEntries([]);
            setPageCount();
            setTotalCount();
          }
          // console.log("setNoOfElements", noOfElements);
        })
        .catch((error) => {
          console.log("Work Order FieldIssue Error", error);
        });
    } catch (error) {
      console.log(error);
      swal(
        "Failed",
        "Something went wrong please check your internet",
        "error"
      );
    }
  };

  const getFieldIssueReportPdfDownload = async () => {
    if (fromDate !== "" && toDate !== "") {
      try {
        setisLoaded(true);
        await getFieldIssuePdfDownload(
          moment(fromDate).format("yyyy-MM-DD"),
          moment(toDate).format("yyyy-MM-DD")
        );
        setisLoaded(false);
        setToDate("")
        setFromDate("")
      } catch (error) {
        setisLoaded(false);
        console.log(error);
        swal(
          "Failed",
          "Something went wrong please check your internet",
          "error"
        );
      }
    } else {
      try {
        setisLoaded(true);
        let token = sessionStorage.getItem("token");
        let fileType = ["pdf"];
        let jobType = ["field visit"];
        let role = sessionStorage.getItem("role");
        let fkUserId = sessionStorage.getItem("pkUserId");
        let result = await getServiceFieldIssuePdf(
          token,
          fileType,
          role,
          fkUserId,
          jobType

        );
        console.log("getServiceFieldIssue Pdf result :-", result);
        setisLoaded(false);
        setToDate("")
        setFromDate("")
      } catch (error) {
        setisLoaded(false);
        console.log("getServiceFieldIssuePdf error :-", error);
      }
    }
  };

  const getFieldIssueReportExcelDownload = async () => {
    if (fromDate !== "" && toDate !== "") {
      try {
        await getFieldIssueExcelDownload(
          moment(fromDate).format("yyyy-MM-DD"),
          moment(toDate).format("yyyy-MM-DD")

        );
        setToDate("")
        setFromDate("")
      } catch (error) {
        console.log("getFieldIssueWorkOrderExcelDownload error :-", error);
      }
    } else {
      try {
        let result = await getServiceFieldIssueExcel();
        console.log("getServiceFieldIssue Excel result :-", result);
        setToDate("")
        setFromDate("")
        let blob = new Blob([result.data], {
          type: "application/vnd.openxmlformats-officedocumnet.spreadsheetml.sheet",
        });
        fileSaver.saveAs(blob, "fieldissuereportexcel.xlsx");
      } catch (error) {
        console.log("getServiceInstallationExcel error :-", error);
      }
    }
  };

  const getCustomerWisePdfDownload = async (e) => {
    try {
      if (selectedCustomer !== "") {
        setisLoaded(true);
        let role = sessionStorage.getItem("role");
        let fkUserId = sessionStorage.getItem("pkUserId");
        let token = sessionStorage.getItem("token");
        let jobType = ["field visit"];
        let fileType = ["pdf"];
        return Axios.get(
          `customerNameWiseWorkOrderReportPdf?fileType=${fileType}&customerName=${selectedCustomer}&jobType=${jobType}&fkUserId=${fkUserId}&role=${role}`,
          {
            headers: { Authorization: `Bearer ${token}` },
            responseType: "arraybuffer",
          }
        ).then((response) => {
          var blob = new Blob([response.data], { type: "application/pdf" });
          fileSaver.saveAs(blob, `customernamewisefieldvisitreport.pdf`);
          setisLoaded(false);
        });
      } else {
        swal("Failed", "Please select Customer Name", "error");
      }
    } catch (error) {
      setisLoaded(false);
      console.log(error);
      swal(
        "Failed",
        "Something went wrong please check your internet",
        "error"
      );
    }
  };

  // const sendImage = (cell) => {
  //   console.log("cell :-", cell);
  //   const newCell = cell.uploadDispenserPhoto?.split(",");
  //   console.log("newCell :-", newCell);
  //   const newTab = window.open({ newCell });
  //   newTab.document.write(
  //     `<img src="data:image/${newCell[0]};base64,${newCell[1]}' />`
  //   );
  // };

  const sendImage = (cell) => {
    console.log("cell :-", cell);
    const newCell = cell.uploadDispenserPhoto?.split(",");
    console.log("newCell :-", newCell);
    const newTab = window.open({ newCell });
    newTab.document.write(
      `<img src='data:image/${newCell[0]};base64,${newCell[1]}' />`
    );
  };

  // Adding srno column to list
  entries.map((item, index) => (item.id = totaloffset + index + 1));

  // Column heading of Field Visit list
  const columns = [
    { dataField: "id", text: "Id" },
    {
      dataField: "modelName",
      text: "Model Name",
      width: 100,
      editable: false,
      headerAlign: "left",
    },
    {
      dataField: "generateUniqueDispenserNo",
      text: "Dispenser No",
      width: 100,
      editable: false,
      headerAlign: "left",
    },
    {
      dataField: "customerName",
      text: "Customer Name",
      width: 100,
      editable: false,
      headerAlign: "left",
    },
    // {
    //   dataField: "dealerName",
    //   text: "Dealer Name",
    //   width: 100,
    //   editable: false,
    //   headerAlign: "left",
    // },
    {
      dataField: "description",
      text: "description",
      formatter: (cell, row) => (
        <div className="tooltip-container">
          <div className="truncated-text">{cell}</div>
          {cell.length > 20 && (
            <span className="tooltip-text">{row.description}</span>
          )}
        </div>
      )
    },
    {
      dataField: "siteAddress",
      text: "Site Address",
      editable: false,
      headerAlign: "left",
      formatter: (cell, row) => (
        <div className="tooltip-container">
          <div className="truncated-text">{cell}</div>
          {cell.length > 20 && (
            <span className="tooltip-text">{row.siteAddress}</span>
          )}
        </div>
      )
    },
    {
      dataField: "siteType",
      text: "Site Type",
      width: 100,
      editable: false,
      headerAlign: "left",
    },
    
    // {
    //   dataField: "uploadDispenserPhoto",
    //   text: "Dispenser Photo",
    //   editable: false,
    //   headerAlign: "left",
    //   formatter: (_, cell) => {
    //     return (
    //       <>
    //         <button
    //           className="btn btn-primary btn-sm"
    //           onClick={() => sendImage(cell)}
    //           disabled={!cell.uploadDispenserPhoto ? true : false}
    //         >
    //           View Image
    //         </button>
    //       </>
    //     );
    //   },
    // },
    {
      dataField: "uploadDispenserPhoto",
      text: "Dispenser Photo",
      editable: false,
      headerAlign: "left",
      // imageFormatter(cell) {
      //   return <img src={cell} />;
      // },
      formatter: (_, cell) => {
        return (
          <>
            <button
              className="btn btn-primary btn-sm"
              onClick={() => sendImage(cell)}
              disabled={!cell.uploadDispenserPhoto ? true : false}
            >
              View Image
            </button>
          </>
        );
      },
      width: 100,
    },
    {
      dataField: "fieldIssueDate",
      text: "Field Job Date",
      editable: false,
      headerAlign: "left",
      formatter: (cell) => {
        return <>{moment(cell).format("DD-MMM-YYYY")}</>;
      },
    },
  ];



  // custom the pagination total
  const customTotal = (from, to, size) => (
    <div>
      Showing {from} to {to} of {size} entries
    </div>
  );

  // callback function when page was changing
  const customSizePerPage = (props) => {
    const { options, currentSizePerPage, onSizePerPageChange } = props;
    const onPageChange = (e) => {
      const page = e.target.value;
      onSizePerPageChange(page);
    };

    return (
      <>
        <Row>
          <Col xs="auto">
            <Form.Select
              value={currentSizePerPage}
              onChange={onPageChange}
              className="pe-5"
            >
              {options.map((o) => (
                <option key={o.page} value={o.page}>
                  {o.text}
                </option>
              ))}
            </Form.Select>
          </Col>
          <Col xs="auto" className="d-flex align-items-center">
            Entries per page
          </Col>
        </Row>
      </>
    );
  };

  return (
    <>
      {isLoaded ? (
        <div className="reportload"></div>
      ) : (
        <>
          <Row>
            <Col className="d-block mb-4 mb-md-0">
              <h5 className="head mb-4">Field Job History Reports</h5>
            </Col>
          </Row>
          {/* {role !== "admin" ? (
        <> */}
          <Row>
            <Col md={3} className="mb-3">
              <div className="form-group">
                <label>From Date</label>
                <DatePicker
                  selected={fromDate}
                  onChange={handleFromDateChange}
                  dateFormat="dd-MMM-yyyy"
                  maxDate={new Date()}
                  className="form-control"
                  placeholderText="DD-MMM-YYYY"
                  showYearDropdown
                  scrollableYearDropdown
                />
              </div>
            </Col>
            <Col md={3} className="mb-3">
              <div className="form-group">
                <label>To Date</label>
                <DatePicker
                  selected={toDate}
                  onChange={handleToDateChange}
                  dateFormat="dd-MMM-yyyy"
                  minDate={fromDate}
                  maxDate={new Date()}
                  className="form-control"
                  placeholderText="DD-MMM-YYYY"
                  showYearDropdown
                  scrollableYearDropdown
                />
              </div>
            </Col>
            <Col md={3} className="mb-3">
              <button
                className="btn btn-secondary mt-lg-4"
                onClick={getFieldByDate}
              >
                <FontAwesomeIcon icon={faSearch} className="me-2" />
                <span>Search By Date</span>{" "}
              </button>
            </Col>
          </Row>
          {/* </>
      ) : (
        ""
      )} */}

          <Formik
            initialValues={{}}
            onSubmit={async (values) => {
              console.log(JSON.stringify(values, null, 2));
            }}
          >
            {(formik) => {
              return (
                <>
                  {/* --- When you use any toolkit functionalities, you are supposed to render toolkit component and
  BootstrapTable as the children of ToolkitProvider --- */}
                  <ToolkitProvider
                    keyField="id"
                    search={true}
                    columns={columns}
                    data={entries}
                    exportCSV={{ onlyExportFiltered: true, exportAll: false }}
                  >
                    {({ baseProps, searchProps, csvProps }) => (
                      //render the Pagination component as a list with left and right arrows
                      <Paginator.PaginationProvider
                        pagination={Pagination({
                          custom: true,
                          alwaysShowAllBtns: true,
                          totalSize: totalCount,
                          disablePageTitle: true,
                          paginationTotalRenderer: customTotal,
                          onPageChange: (page) => {
                            handlePageChange(page);
                            // alert(`page: ${page}, sizePerPage: ${sizePerPage}`);
                          },
                        })}
                      >
                        {({ paginationProps, paginationTableProps }) => (
                          <Card>
                            <div className="table-responsive py-2">
                              <Card.Header>
                                <Row>
                                  <Col xs={12} md={6} className="py-1">
                                    {/* <Paginator.SizePerPageDropdownStandalone
                                    {...paginationProps}
                                  /> */}
                                  </Col>
                                  <Col
                                    xs={12}
                                    md={6}
                                    className="d-flex justify-content-md-end py-1"
                                  >
                                    <button
                                      className="btn btn-secondary"
                                      // onClick={getCustomerWisePdfDownload}
                                      onClick={getFieldIssueReportPdfDownload}
                                    >
                                      <FontAwesomeIcon
                                        icon={faDownload}
                                        className="me-2"
                                      />
                                      <span>PDF</span>{" "}
                                    </button>
                                    <button
                                      className="btn btn-secondary mx-2"
                                      onClick={getFieldIssueReportExcelDownload}
                                    >
                                      <FontAwesomeIcon
                                        icon={faDownload}
                                        className="me-2"
                                      />
                                      <span>Excel</span>
                                    </button>
                                  </Col>
                                </Row>
                              </Card.Header>
                              <Table
                                {...baseProps}
                                {...paginationTableProps}
                                bodyClasses="border-0"
                                rowClasses="border-bottom"
                                classes="table-flush dataTable-table"
                                // selectRow={selectRow}
                                filter={filterFactory()}
                                headerClasses="header-class"
                                hover
                                striped
                                condensed
                                remote={{ pagination: true }}
                                cellEdit={cellEditFactory({
                                  mode: "click",
                                  blurToSave: true,
                                  afterSaveCell: (
                                    oldValue,
                                    newValue,
                                    row,
                                    column
                                  ) => {
                                    const changeRowData = {
                                      selectedRow: row,
                                      cellChange: newValue,
                                      columnChange: column,
                                    };
                                    setChangeRowData(changeRowData);
                                  },
                                })}
                                wrapperClasses="table-responsive"
                              />
                              <Card.Footer>
                                <Row>
                                  <Col
                                    xs={12}
                                    md={6}
                                    className="d-flex align-items-center py-1"
                                  >
                                    {/* <Paginator.PaginationTotalStandalone
                            {...paginationProps}
                          /> */}
                                  </Col>
                                  <Col
                                    xs={12}
                                    md={6}
                                    className="d-flex justify-content-md-end align-items-center mb-0 py-1"
                                  >
                                    <Paginator.PaginationListStandalone
                                      {...paginationProps}
                                    />
                                  </Col>
                                </Row>
                              </Card.Footer>
                            </div>
                          </Card>
                        )}
                      </Paginator.PaginationProvider>
                    )}
                  </ToolkitProvider>
                </>
              );
            }}
          </Formik>
        </>
      )}
    </>
  );
};
// }};
